/*----------------------------------------
 Check for breakpoint view */

const resultsScrollClass = '.results-scroll';
const resultsListContainerClass = '.pcl-results-list';
const defaultMobileZoom = 9;
const defaultZoom = 10;

function isDesktopView() {
	if  (isDesktopViewV1() || isDesktopViewV2()) {
	 	return true;
	} else {
		const bp = lthelp && lthelp.getBreakpoint();
		return bp === "lg" || bp === "xl";
	}
}

function isDesktopViewV1() {
	return $(resultsScrollClass).css('overflow') === 'auto';
}

function isDesktopViewV2() {
	return $(resultsListContainerClass).css('overflow-y') === 'scroll';
}

function getZoomLevel() {
	return isDesktopView() ? defaultZoom : defaultMobileZoom;
}

const returnVal = {
	isDesktopView,
	getZoomLevel
};

export default returnVal;
